/**
 * 群组 API
 */

import apiClient from './client';

export interface Group {
  id: string;
  group_id: string;
  owner_id: string;
  is_owner: boolean;
  group_name: string;
  external_group_id?: string;
  external_platform?: 'dingtalk' | 'feishu' | 'wechat';
  robot_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateGroupRequest {
  group_name: string;
  external_group_id?: string;
  external_platform?: 'dingtalk' | 'feishu' | 'wechat';
}

export interface UpdateGroupRequest {
  group_name?: string;
  external_group_id?: string;
  external_platform?: 'dingtalk' | 'feishu' | 'wechat';
}

export interface GroupListResponse {
  items: Group[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

/**
 * 获取群组列表
 */
export async function getGroups(page = 1, limit = 10): Promise<GroupListResponse> {
  const response = await apiClient.get('/groups', {
    params: { page, limit, status: 'all' },
  });
  return response.data;
}

/**
 * 创建群组
 */
export async function createGroup(data: CreateGroupRequest): Promise<Group> {
  const response = await apiClient.post('/groups', data);
  return response.data;
}

/**
 * 获取群组详情
 */
export async function getGroupById(id: string): Promise<Group> {
  const response = await apiClient.get(`/groups/${id}`);
  return response.data;
}

/**
 * 更新群组
 */
export async function updateGroup(id: string, data: UpdateGroupRequest): Promise<Group> {
  const response = await apiClient.put(`/groups/${id}`, data);
  return response.data;
}

/**
 * 删除群组
 */
export async function deleteGroup(id: string): Promise<void> {
  await apiClient.delete(`/groups/${id}`);
}

/**
 * 获取群内机器人列表
 */
export async function getGroupRobots(groupId: string, page = 1, limit = 20): Promise<any> {
  const response = await apiClient.get(`/groups/${groupId}/robots`, {
    params: { page, limit, status: 'all' },
  });
  return response.data;
}

/**
 * 获取或刷新加群令牌
 */
export async function refreshJoinToken(groupId: string): Promise<{ token: string; expiresAt: string }> {
  const response = await apiClient.post(`/groups/${groupId}/join-token`);
  return response.data;
}
